import React from 'react';
import styled, { css } from 'styled-components';
import { capitalizeFirstLetter } from '../../../utils';

const Container = styled.div`
  display: flex;
  letter-spacing: -0.2px;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Label = styled.span`
  font-size: 13px;
  color: 'black';
  letter-spacing: -0.2px;
  width: 100px;
  text-align: left;
  padding: 5px 5px 5px 7px;
  margin-right: 32px;
  margin-top: 2px;

  @media (max-width: 1220px) {
    margin-right: calc((27 / 320) * 100vw - 71px);
  }
`;

const Status = styled.span`
  margin-top: 1px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  display: inline-block;
  background-color: lightgray;
  color: gray;
  padding: 5px;
  border-radius: 15px;
  width: 48px;
  text-align: center;
  margin-right: 39px;

  @media (max-width: 1220px) {
    margin-right: calc((34 / 320) * 100vw - 90px);
  }

  ${props => css`
    color: ${props.active ? props.activeColor : 'gray'};
    background-color: ${props.active
      ? props.activeBackgroundColor
      : 'lightgray'};
  `}
`;

const prepAreas = {
  general: 'Front of House',
  kitchen: 'Kitchen',
};

function PublishStatus(props) {
  const { theme, status, level, label } = props;

  return (
    <Container>
      {level <= 2 ? (
        <Label
          activeColor={theme.palette.fatsoma.black}
          active={status === 'live'}
        >
          {prepAreas[label] || 'Unset'}
        </Label>
      ) : null}

      {level <= 2 ? (
        <Status
          activeColor={theme.palette.fatsoma.black}
          activeBackgroundColor={theme.palette.fatsoma.yellow}
          active={status === 'live'}
        >
          {capitalizeFirstLetter(status)}
        </Status>
      ) : null}
    </Container>
  );
}

export default PublishStatus;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/PublishStatus/publish-status.jsx